// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"f8aa8d98","472":"0033c0cb"}[chunkId] + ".chunk.js";
};